import { getIdpHealth } from '@/services/idpAnalytics'
import type { IdpDataHealthDTO, IdpWebKey } from '@/services/idpAnalytics'
import { webKeysForFilter } from './siteWebKeys'

export type IdpHealthFetcher = (params: { webKey: IdpWebKey }) => Promise<IdpDataHealthDTO | null | undefined>

function unhealthySnapshot(webKey: IdpWebKey): IdpDataHealthDTO {
  return {
    webKey,
    healthy: false,
    kpis: [{ name: 'API', status: 'ERROR', value: 0, target: 1 }],
    rollupLags: [],
    fieldFillRates: [],
  }
}

export function loadIdpHealthSnapshots(
  filterSite: string,
  fetchHealth: IdpHealthFetcher = getIdpHealth,
  siteFilters?: string[],
): Promise<IdpDataHealthDTO[]> {
  return Promise.all(webKeysForFilter(filterSite, siteFilters).map(webKey => (
    fetchHealth({ webKey })
      .then(snapshot => snapshot || unhealthySnapshot(webKey))
      .catch(() => unhealthySnapshot(webKey))
  )))
}
